<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Cargues Dinámicos" key="1">
        <g-master
          :endpoint="dynamicLoadMaster.endpoint"
          :tableSetup="dynamicLoadMaster.tableSetup"
          :modalFieldsSetup="dynamicLoadMaster.modalFieldsSetup"
          ref="master"
          @action="masterActions"
          modalWidth="90%">
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                  <a-input
                    v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
                  <a-textarea autoSize
                              v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Tipo de cargue')"
                            :formItemConfig="fiOptions"
                            :selectedObj.sync="tipoCargueSeleccionado"
                            :decorator="['load_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="dynamic_load_type"
                >
                </g-dropdown>
              </a-col>

              <a-col v-show="esPhp" v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Clase php')">
                  <a-input v-decorator="['php_class', { rules: [{ required: esPhp, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>

              <div v-show="esPl">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Pre-Proceso')">
                    <a-textarea autoSize
                                v-decorator="['pre_process', { rules: [{ required: esPl, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Proceso de Linea')">
                    <a-textarea autoSize
                                v-decorator="['line_process', { rules: [{ required: esPl, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Post-Proceso')">
                    <a-textarea autoSize
                                v-decorator="['post_process', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Etiqueta Post-Proceso')">
                    <a-input
                      v-decorator="['post_process_label', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Proceso Cancelación')" v-bind="fiOptions">
                    <a-textarea autoSize
                                v-decorator="['cancel_process', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Etiqueta Proceso Cancelación')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['cancel_process_label', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Proceso Reversión')" v-bind="fiOptions">
                    <a-textarea autoSize
                                v-decorator="['revert_process', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Etiqueta Proceso Reversión')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['revert_process_label', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </div>

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Ayuda html')" v-bind="fiOptions">
                  <a-textarea autoSize
                              v-decorator="['help_html', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <g-dropdown endpoint="role"
                            :label="$t('Roles') "
                            :selectConfig="{mode:'multiple'}"
                            :formItemConfig="fiOptions"
                            :decorator="['roles', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                >
                </g-dropdown>
              </a-col>

              <a-col v-bind="colOptions">
                <g-dropdown
                  :label="$t('Plantilla notificación')"
                  :formItemConfig="fiOptions"
                  endpoint="mail_templates"
                  :decorator="['mail_template_id']">
                </g-dropdown>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Notificación CC')">
                  <a-input
                    v-decorator="['mail_cc']"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Activo')" :has-feedback="false">
                  <a-checkbox v-decorator="['active', {valuePropName: 'checked'}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-alert
                message="Información"
                type="info"
                show-icon
              >
                <template slot="description">
                  Los campos de procesos <strong>"Pre-Proceso", "Proceso de linea", "Post-Proceso", "Proceso
                  Cancelación" y "Proceso de Reversión"</strong> cumplen las siguientes condiciones
                  <ul>
                    <li>Deben tener el formato begin [paquete].[proceso|funcion](:param1,...,:paramN); end;</li>
                    <li><strong>"paramN"</strong> Corresponde a columnas del excel o a parámetros globales.</li>
                    <li>Deben ser un bloque anónimo y terminar en punto y coma <strong>(;)</strong></li>
                    <li>Puden utilziar los siguientes parametros globales
                      <ul>
                        <li><strong>pwebuser</strong> -> usuario que cargó el archivo</li>
                        <li><strong>pweblinea</strong> -> número linea que se está validando. No disponible durante pre,
                          post, cancelar y reversar.
                        </li>
                        <li><strong>pwebresult</strong> -> variable de salida tipo number, 1 exito 0 fallido. <strong>Ohligatorio</strong>
                        </li>
                        <li><strong>pweboutput</strong> -> variable de salida tipo clob, log de salida. Es registrado de
                          forma automática en la tabla de logs <strong>Ohligatorio</strong></li>
                        <li><strong>pwebexec</strong> -> id de la ejecusión en curso</li>
                      </ul>
                    </li>
                    <li>De manera obligatoria deben incluir los parámetros <strong>pwebresult</strong> y <strong>pweboutput</strong>
                    </li>
                    <li>Ejemplo preprocesar: <strong>begin prPreprocesar(:pwebuser,:pwebresult,:pweboutput);
                      end;</strong></li>
                    <li>Ejemplo procesar linea: <strong> begin
                      prPreprocesaLinea(:idemp,:nombre,:pwebuser,:pwebresult,:pweboutput); end;</strong>
                      donde :idemp y :nombre son columnas del excel que se está cargando.
                    </li>
                  </ul>
                  El campo Notificación CC permite enviar copias de la notificación a correos electrónicos diferentes al
                  del usuario loggeado. ste campo debe separar los correos utilizando un punto y coma
                  <strong>(;)</strong>.
                  Tambien se puede agregar un nombre al destinatario utilizando el formato [nombre]|[email], Ejemplo:
                  <strong>pepito triviño|pepito@correo.com;otrodestinatario@coreo.com</strong>
                </template>
              </a-alert>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Campos de carga dinámicos" key="1">
        <dynamic-load-fields v-if="idDynamicLoad" :dynamic_load_id="idDynamicLoad"/>
        <span v-else>Seleccione un cargue dinámico para ver más.</span>
      </a-tab-pane>
      <a-tab-pane tab="Parámetro de carga dinámica" key="2">
        <dynamic-load-params v-if="idDynamicLoad" :dynamic_load_id="idDynamicLoad"/>
        <span v-else>Seleccione un cargue dinámico para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        dynamic_load_type: {
          h_lookup_type: 'DYNAMIC_LOAD_TYPE',
          use_code: true
        },
        tipoCargueSeleccionado: {},
        esPhp: false,
        esPl: false,
        dynamicLoadMaster: {
          endpoint: 'dynamic_loads',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Tipo de cargue', dataIndex: 'load_type', sorter: true},
              {title: 'Clase php', dataIndex: 'php_class', sorter: true},
              {title: 'Activo', dataIndex: 'active_desc', sorter: true},
              {title: 'Plantilla Email', dataIndex: 'mail_template_desc', sorter: true},
              {title: 'Mail CC', dataIndex: 'mail_cc', sorter: true},
              {title: 'Etiqueta Post Proceso', dataIndex: 'post_process_label', sorter: true},
              {title: 'Pre-Proceso', dataIndex: 'pre_process', sorter: true},
              {title: 'Línea-proceso', dataIndex: 'line_process', sorter: true},
              {title: 'Post-proceso', dataIndex: 'post_process', sorter: true},
              {title: 'Proceso cancelación', dataIndex: 'cancel_process', sorter: true},
              {title: 'Etiqueta proceso cancelación', dataIndex: 'cancel_process_label', sorter: true},
              {title: 'Proceso reversión', dataIndex: 'revert_process', sorter: true},
              {title: 'Etiqueta proceso reversión', dataIndex: 'revert_process_label', sorter: true},
              {title: 'Roles', dataIndex: 'roles', sorter: true},
              {title: 'Ayuda html', dataIndex: 'help_html', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'active', type: 'boolean'},
            {name: 'pre_process'},
            {name: 'post_process'},
            {name: 'line_process'},
            {name: 'mail_cc'},
            {name: 'mail_template_desc'},
            {name: 'mail_template_id'},
            {name: 'post_process_label'},
            {name: 'description'},
            {name: 'load_type'},
            {name: 'php_class'},
            {name: 'cancel_process'},
            {name: 'cancel_process_label'},
            {name: 'revert_process'},
            {name: 'revert_process_label'},
            {name: 'roles'},
            {name: 'help_html'}
          ]
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        }
      }
    },
    computed: {
      idDynamicLoad () {
        return this.dynamicLoadMaster.tableSetup.selectedRows.length > 0 ? this.dynamicLoadMaster.tableSetup.selectedRows[0].id : null
      }
    },
    methods: {
      masterActions (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!this.$isEmpty(action.record.roles)) {
              this.$refs.master.modal.form.setFieldsValue({
                roles: action.record.roles.split(',')
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                roles: undefined
              })
            }
            if (action.record.load_type === 'PHP') {
              this.esPhp = true
              this.esPl = false
            } else if (action.record.load_type === 'PL') {
              this.esPl = true
              this.esPhp = false
            }
            break
          case 'masterCreate':
            this.esPhp = false
            this.esPl = false
            break
          case 'fieldsChange':
            if (!this.$isEmpty(action.changedFields)) {
              if (!this.$isEmpty(action.changedFields.load_type)) {
                if (!this.$isEmpty(action.changedFields.load_type.value)) {
                  if (action.changedFields.load_type.value === 'PHP') {
                    this.esPhp = true
                    this.esPl = false
                  } else if (action.changedFields.load_type.value === 'PL') {
                    this.esPl = true
                    this.esPhp = false
                  }
                } else {
                  this.esPl = false
                  this.esPhp = false
                }
              }
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GDynamicLoads/DynamicLoads.vue